import { forwardRef } from "react";
import "./index.scss";

export const SelectOption = forwardRef(
  (
    {
      value,
      name,
      id,
      onChange,
      onBlur,
      hasError = false,
      customClassName = "",
      options,
      ...props
    },
    ref
  ) => {
    return (
      <select
        name={name}
        id={id}
        className={`select-option ${customClassName} ${
          hasError ? "select-option--error" : ""
        }`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        ref={ref}
        {...props}
      >
        {options.map((item) => (
          <option
            disabled={!item.value}
            hidden={!item.value}
            className="option-item"
            value={item.value}
            key={item.label}
            label={item.label}
          />
        ))}
      </select>
    );
  }
);
